import { Fragment, useMemo } from 'react'
import CustomToolTip from '../../../CommonComponents/CustomToolTip'
import useModals from '../../hooks/useModals';
import { ActivitySvg, ConsoleSvg, FilesQueueSvg, GroundScheduleSvg, NotificationSvg, OnboardScheduleSvg, PinnedSvg, TelemetrySvg } from './Svgs';
import useUrlParams from '../../hooks/useUrlParams';
import { ModalType } from '../../types';
import useScenario from '../../hooks/useScenario';
import useConsole from '../../hooks/useConsole';
import useTrueTwin from '../../hooks/useTrueTwin';
import useFiles from '../../hooks/useFiles';
import { isOperateMode } from '../../hooks/utils';
import ActiveTaskOverlay from '../center/modals/schedule/custom-schedule/ActiveTaskOverlay';
import useFilters from '../../hooks/useFilters';

const RightContainer = () => {
    const { dashboard, scenario_id, sat_id, mission_id } = useUrlParams()
    const { scenario } = useScenario()
    const { open_modal, close_modal, get_modal_details, pinned_modal } = useModals()
    const { getFilterOptions, getFilterGroups } = useFilters()
    const { truetwin_id } = useTrueTwin()
    const { getAllDestinationIds } = useFiles()

    const hide_button = useMemo(() => (dashboard === 'quick-deploy' || scenario?.scenarioOperation === 'LEOP'), [dashboard, scenario?.scenarioOperation])

    const isValidateScenario = (scenario?.scenarioDeploymentType ?? '').toUpperCase() === 'VALIDATE'
    const isValidateSummary = isValidateScenario && dashboard === 'summary'

    const toggle_modal = (modal: ModalType) => {
        if (scenario?.scenarioOperation === 'LEOP' && (modal === 'onboard_schedule' || modal === 'console')) return

        const modal_details = get_modal_details(modal)
        if (modal_details.open && modal_details.pinned) return
        else if (modal_details.open && !modal_details.pinned) {
            close_modal(modal)
        } else {
            open_modal(modal)
        }
    }

    const getLeopTootipMessage = (type: string) => {
        return type + ' is not available for LEOP simulation'
    }


    const operateMode = isOperateMode(dashboard, scenario)
    const handleOpenConsole = () => {
        toggle_modal('console')
        getFilterOptions(truetwin_id, scenario_id, sat_id, mission_id) //api to get the options for filter
        getFilterGroups(scenario_id) //api to get filter groups for console
        if (operateMode) {
            getAllDestinationIds()
        }
        const event = new CustomEvent("openConsole"); //to reset filters and don't save them
        window.dispatchEvent(event);
    }

    return (
        <Fragment>
            {!isValidateSummary && (
                <div className={`right__button__container`} onClick={(e: any) => { e.stopPropagation() }} onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}>
                    {operateMode && <ActiveTaskOverlay />}
                    <CustomToolTip title={`${scenario?.scenarioOperation === 'LEOP' ? getLeopTootipMessage('Schedule') : 'Onboard Schedule'}`} placement='bottom'>
                        <button className={`right__section__button ${hide_button && 'hide__btn'} ${dashboard === 'operate-0.1' ? 'left__btn' : 'single__btn'} ${get_modal_details('onboard_schedule').open && 'active'}`} onClick={() => { toggle_modal('onboard_schedule') }}>
                            <OnboardScheduleSvg />
                            <PinnedSvg showPinned={get_modal_details('onboard_schedule').pinned} />
                        </button>
                    </CustomToolTip>
                    <CustomToolTip title='Ground Schedule' placement='bottom'>
                        <button className={`right__section__button ${dashboard === 'operate-0.1' ? 'right__btn' : 'hide__btn'} ${get_modal_details('ground_schedule').open && 'active'}`} onClick={() => { toggle_modal('ground_schedule') }}>
                            <GroundScheduleSvg />
                            <PinnedSvg showPinned={get_modal_details('ground_schedule').pinned} />
                        </button>
                    </CustomToolTip>
                </div>
            )}
            <div className={`right__button__container`} onClick={(e: any) => { e.stopPropagation() }} onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}>
                <CustomToolTip title={`${scenario?.scenarioOperation === 'LEOP' ? getLeopTootipMessage('Console') : 'Console'}`} placement='bottom'>
                    <button
                        disabled={scenario?.scenarioOperation === 'LEOP'}
                        className={`right__section__button left__btn ${get_modal_details('console').open && 'active'}`} onClick={() => {
                            handleOpenConsole()
                        }}>
                        <ConsoleSvg />
                        <PinnedSvg showPinned={get_modal_details('console').pinned} />
                    </button>
                </CustomToolTip>
                <CustomToolTip title={`Telemetry`} placement='bottom'>
                    <button className={`right__section__button center__btn ${get_modal_details('telemetry').open && 'active'}`} onClick={() => { toggle_modal('telemetry') }}>
                        <TelemetrySvg />
                        <PinnedSvg showPinned={get_modal_details('telemetry').pinned} />
                    </button>
                </CustomToolTip>
                <CustomToolTip title={`${scenario?.scenarioOperation === 'LEOP' ? getLeopTootipMessage('File Queue') : 'File Queue'}`} placement='bottom'>
                    <button
                        disabled={scenario?.scenarioOperation === 'LEOP'}
                        className={`right__section__button right__btn ${get_modal_details('filequeue').open && 'active'}`} onClick={() => { toggle_modal('filequeue') }}>
                        <FilesQueueSvg />
                        <PinnedSvg showPinned={get_modal_details('filequeue').pinned} />
                    </button>
                </CustomToolTip>
            </div>
            {!isValidateSummary && (
                <div className={`right__button__container ${dashboard !== 'operate-0.1' && 'hide__section'}`} onClick={(e: any) => { e.stopPropagation() }} onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}>
                    <CustomToolTip title='Activity' placement='bottom'>
                        <button className={`right__section__button left__btn disabled`}>
                            <ActivitySvg />
                        </button>
                    </CustomToolTip>
                    <CustomToolTip title='Notification' placement='bottom'>
                        <button className={`right__section__button right__btn disabled`}>
                            <NotificationSvg />
                        </button>
                    </CustomToolTip>
                </div>
            )}
        </Fragment >
    )
}

export default RightContainer